<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">Reset Password</h2>
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <p class="dialog-subtitle">Enter your email address to receive a password reset link.</p>

    <div *ngIf="message" class="message-box" style="text-align: left; line-height: 1.5;">
      <div style="font-weight: 600; margin-bottom: 8px;">{{ message }}</div>
      <div style="font-size: 13px; color: #15803d; font-weight: normal;">
        <strong>Note:</strong> If you do not see the email in your inbox within a few minutes, please check your spam or junk folder.
      </div>
    </div>

    <form (ngSubmit)="onSubmit()" #resetForm="ngForm" *ngIf="!message">
      <div class="full-width mb-16">
        <label class="input-label">Email ID <span class="required-star">*</span></label>
        <div class="custom-input-box" [class.error]="resetForm.submitted && !email">
          <mat-icon class="prefix-icon">mail_outline</mat-icon>
          <input type="email" placeholder="Ex: user@example.com" [(ngModel)]="email" name="email" required />
        </div>
        <div class="error-msg" *ngIf="resetForm.submitted && !email">
          Email is required
        </div>
      </div>

      <button type="submit" class="primary-cta" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Sending...' : 'Send Reset Link' }}
      </button>
    </form>
  </div>
</div>
